var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"hide-header":true,"hide-footer":true,"content-class":"modal-blue","id":"key-vocabulary-modal","centered":""},on:{"shown":function($event){return _vm.onShown()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }